import styled from 'styled-components';
import {StyledProps} from './typings';
import colors from '../../theme/constants/colors';

export const StyledColourSelector = styled.span<StyledProps>`
  cursor: pointer;

  &.selected {
    border-color: ${colors.red100};
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      border-color: ${colors.red100};
    }
  }

  display: inline-block;
  margin: 0 5px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  padding: 3px;
  border: solid 2px transparent;

  span {
    width: 100%;
    height: 100%;
    background-color: #${(props) => props.$color};
    border-radius: 50%;
    display: block;
    ${(props) => props.$color === 'ffffff' && `border: 1px solid ${colors.grey100}`}
  }
`;

export const StyledColourContainer = styled.div``;
